module.exports = __webpack_public_path__ + "img/appAsset--sire-ax.4cccaf20.svg";